import { animate, query, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { AnnouncementService } from '../../../services/announcement/announcement.service';
import { WindowReferenceService } from '../../../services/window-reference/window-reference.service';

export const AnnouncementHeight = 55;

@Component({
    selector: 'lsq-announcement',
    template: `
        <div
            class="lsq-announcement-component"
            [ngClass]="{ 'global-search-is-expanded': globalSearchIsExpanded }"
        >
            <lsq-announcement-row
                *ngFor="let announcement of announcementService.announcementsStream | async"
                [announcement]="announcement"
                [@slide]
            >
            </lsq-announcement-row>
        </div>
    `,
    styleUrls: ['./lsq-announcement.component.scss'],
    animations: [
        trigger('slide', [
            transition(':leave', [
                style({
                    'z-index': 0
                }),
                query('.lsq-announcement-row', [
                    animate(
                        '400ms cubic-bezier(0, 0.9, 0.2, 1)',
                        style({
                            height: 0,
                            'padding-top': 0,
                            'padding-bottom': 0
                        })
                    )
                ])
            ])
        ])
    ]
})
export class LsqAnnouncementComponent {
    @Input() public globalSearchIsExpanded: boolean;

    constructor(
        public announcementService: AnnouncementService,
        public windowReferenceService: WindowReferenceService
    ) {}
}
